var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBasketOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.71525,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.9999H24.196C24.8208 11.9999 25.1332 11.9999 25.3619 12.1008C26.3736 12.5468 25.9213 13.6707 25.7511 14.4783C25.7187 14.6317 25.6188 14.725 25.5 14.8012M11.5 11.9999H7.80397C7.17922 11.9999 6.86684 11.9999 6.63812 12.1008C5.6264 12.5468 6.07874 13.6707 6.24894 14.4783C6.27952 14.6234 6.37896 14.7469 6.51841 14.8131C7.09673 15.0875 7.50177 15.608 7.60807 16.2133L8.20066 19.5877C8.46138 21.0724 8.55052 23.1941 9.8516 24.2401C10.8062 24.9999 12.1816 24.9999 14.9325 24.9999H16",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1408 17.442C19.3476 16.711 20.4008 17.0056 21.0335 17.4749C21.293 17.6673 21.4227 17.7635 21.499 17.7635C21.5753 17.7635 21.705 17.6673 21.9645 17.4749C22.5972 17.0056 23.6504 16.711 24.8572 17.442C26.4409 18.4015 26.7992 21.5668 23.1462 24.2372C22.4504 24.7459 22.1025 25.0002 21.499 25.0002C20.8955 25.0002 20.5476 24.7459 19.8518 24.2372C16.1988 21.5668 16.5571 18.4015 18.1408 17.442Z",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15L14 7M19 7L21.5 12",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasketOutline);
export default __webpack_public_path__ + "static/media/shoppingBasketOutline.e6d53bac27fc5fb4763337198203073b.svg";
export { ForwardRef as ReactComponent };